/**
 * Number of attachments requested per page.
 *
 * Deliberately a constant and NOT derived from `gridSize`. Page size is a data
 * concern; grid size is a presentation concern. Deriving one from the other
 * (`limit = gridSize * 4`) pinned every page to exactly four rows, so the taller
 * the density the shorter the rendered content — past ~10 columns page one no
 * longer overflowed the viewport, no scroll event ever fired, and infinite
 * scroll dead-ended on page one.
 */
export const GALLERY_PAGE_SIZE = 48;

/**
 * Distance from the bottom of the scroll container at which the next page is
 * requested, for the virtualised grid's scroll listener.
 */
export const GALLERY_LOAD_MORE_OFFSET_PX = 150;

/**
 * Same idea for the IntersectionObserver-driven section views: start loading
 * while the sentinel is still this far below the fold.
 */
export const GALLERY_LOAD_MORE_ROOT_MARGIN = '300px';
